import React from "react";
import _ from "lodash";
import Button from "Components/button/Button";
import TranslatedString from "Components/TranslatedString";
import t from "Utils/translation";

import cx from "classnames";
import s from "./recapAddForm.scss";

export default class Recap extends React.Component {
  constructor(props) {
    super(props);
    this.submit = this.submit.bind(this);

    let organizedResources = {};

    _.each(props.data.emailAddressSelected, (v, email) => {
      let dom = email.match(/@(.*)$/)[1];

      if (!organizedResources[dom]) {
        organizedResources[dom] = [];
      }

      organizedResources[dom].push(email);
    });

    this.state = { organizedResources };
  }

  submit(e) {
    e.preventDefault();
    this.props.submitForm();
  }

  render() {
    const {
      formData,
      isFormLoading,
      data: { emailAddressSelected },
    } = this.props;
    const { organizedResources } = this.state;

    return (
      <div className="formsPage">
        {this.props.stepper}

        <div className={cx("sectionTitle", "titleFP")}>{t("delegate.add.title.step4")}</div>

        <div className="wrapScrollFP">
          <div className="infoFP">
            <div className="sectionDesc">
              {<TranslatedString>delegate.add.desc.step4</TranslatedString>}
            </div>
            <Button className="btnDocsFP" docsKey="delegates_add" color="docs" sizeSmall>
              button.docs
            </Button>
          </div>

          <div className="wrapFormsFP">
            <div className="formsFP">
              <div className={cx("inputFull2", s.sectionRecap)}>
                <div className={s.labelRecapt}>{t("detailInfo.label.firstName")}</div>
                <div className={s.dataRecapt}>{formData.firstname}</div>
              </div>

              <div className={cx("inputFull2", s.sectionRecap)}>
                <div className={s.labelRecapt}>{t("detailInfo.label.lastName")}</div>
                <div className={s.dataRecapt}>{formData.lastname}</div>
              </div>

              <div className={cx("inputFull2", s.sectionRecap)}>
                <div className={s.labelRecapt}>{t("detailInfo.label.company")}</div>
                <div className={s.dataRecapt}>{formData.company || "-"}</div>
              </div>

              <div className={cx("inputFull2", s.sectionRecap)}>
                <div className={s.labelRecapt}>{t("detailInfo.label.email")}</div>
                <div className={s.dataRecapt}>{formData.email_address}</div>
              </div>

              <div className={cx("inputFull2", s.sectionRecap)}>
                <div className={s.labelRecapt}>{t("detailInfo.label.expiration")}</div>
                <div className={s.dataRecapt}>
                  {formData.expiration
                    ? formData.expiration.toLocaleDateString()
                    : t("detailInfo.data.noExpiration")}
                </div>
              </div>

              <div className={cx("inputFull2", s.sectionRecap)}>
                <div className={s.labelRecapt}>{t("detailInfo.label.messages.viewDate")}</div>
                <div className={s.dataRecapt}>
                  {formData.always
                    ? t("detailInfo.data.messages.viewDate.noLimits")
                    : `${formData.visualization_start.toLocaleDateString()} - ${formData.visualization_end.toLocaleDateString()}`}
                </div>
              </div>

              <div className={cx("inputFull2", s.sectionRecap)}>
                <div className={s.labelRecapt}>{t("detailInfo.label.permissions")}</div>
                <div className={s.dataRecapt}>
                  {_.map(organizedResources, (ems, dom) => {
                    return (
                      <div className={s.wrapDomain} key={dom}>
                        <div className={s.nameDomain}>{dom}</div>

                        {_.map(ems, (em) => (
                          <div className={s.rowDomain} key={em}>
                            <div>{em}</div>

                            <div className={s.visualization}>
                              {emailAddressSelected[em] === "full"
                                ? t("folderMapper.label.full")
                                : t("folderMapper.label.subject")}
                            </div>
                          </div>
                        ))}
                      </div>
                    );
                  })}
                </div>
              </div>
            </div>
            <div className="footerFP">
              <Button color="text" type="button" onClick={() => this.props.resetAndGoBack()}>
                button.cancel
              </Button>
              <Button color="green" loading={isFormLoading} onClick={this.submit}>
                button.create
              </Button>
            </div>
          </div>
        </div>
      </div>
    );
  }
}
